export const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(email);

export const formatDateToYYYYMMDD = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};


export const formatPhoneNumber = (phoneNumber) => {

  
};